export const routes = {
    Auth: {
        Login: '/login',
        Register: '/register',
    },
    Dashboard: '/dashboard',
    Bots: {
        List: '/bots',
        Create: '/bots/new',
        Detail: '/bots/:id',
        Overview: '',
        Questions: 'questions',
        DealRules: 'deal-rules',
        Reminders: 'reminders',
        Conversations: 'conversations',
        UTM: 'utm',
    },
    Campaigns: {
        List: '/campaigns',
        Create: '/campaigns/new',
        Detail: '/campaigns/:id',
    },
    Templates: '/templates',
    Integrations: {
        List: '/integrations',
        AmoCRMDetail: '/integrations/amocrm/:id',
        AmoCRMCallback: '/auth/amocrm',
    },
    Analytics: {
        Dashboard: '/analytics',
        Bot: '/analytics/bots/:id',
    },
    Settings: '/settings',
};
